import React from 'react';
import { Employee, Division, DivisionKey } from '../../types/orgchart.types';
import { useLocale } from '../../contexts/LocaleContext';
import './Tooltip.css';

interface TooltipProps {
  employee: Employee | null;
  divisions: Record<DivisionKey, Division>;
  position: { x: number; y: number };
  visible: boolean;
  manager?: Employee | null;
}

export const Tooltip: React.FC<TooltipProps> = ({ employee, divisions, position, visible, manager }) => {
  const { t } = useLocale();

  if (!employee || !visible) return null;

  const division = divisions[employee.division as DivisionKey];
  const icon = division?.icon || '👤';
  const divisionName = division?.name || employee.division;
  const departmentName = employee.deptNum
    ? division?.departments?.find(d => d.number === employee.deptNum)?.name
    : null;

  return (
    <div
      className={`node-tooltip ${visible ? 'visible' : ''}`}
      style={{ left: position.x + 15, top: position.y + 15 }}
    >
      <div className="tooltip-header">
        <div className="tooltip-avatar">{icon}</div>
        <div>
          <div className="tooltip-name">{employee.name}</div>
        </div>
      </div>
      <div className="tooltip-info">
        <strong>{t('tooltip.division')} {employee.divNum}:</strong> {divisionName}<br />
        {departmentName && (
          <>
            <strong>{t('tooltip.department')} {employee.deptNum}:</strong> {departmentName}<br />
          </>
        )}
        <strong>{t('tooltip.product')}:</strong> {employee.vfp || t('tooltip.notAvailable')}
        {manager && (
          <>
            <br /><strong>👤 {t('tooltip.directManager')}:</strong> {manager.name}
          </>
        )}
        {employee.email && (
          <>
            <br /><strong>📧 {t('tooltip.email')}:</strong> {employee.email}
          </>
        )}
        {employee.phone && (
          <>
            <br /><strong>📞 {t('tooltip.phone')}:</strong> {employee.phone}
          </>
        )}
      </div>
    </div>
  );
};
